export const getNewLandingPageTypes = {
  REQUEST: 'GET_NEW_LANDING_PAGE_REQUEST',
  SUCCESS: 'GET_NEW_LANDING_PAGE_SUCCESS',
  FAILED: 'GET_NEW_LANDING_PAGE_FAILED',
};
